import React, { Component } from 'react'
import { toast } from 'react-toastify'
import _ from 'lodash'
import { connect } from 'react-redux'
import { Get, Put, } from 'utils/axios-token'

import Lang from 'Lang/General'
import { DEFAULT_EMAIL_JSONB } from '../assets'

const HOC = ( WrappedComponent ) => {
  class WithHOC extends Component {
    state = {
      loading: false,
      emailTemplates: {content_jsonb: DEFAULT_EMAIL_JSONB },
      emailTemplateContentJsonb: DEFAULT_EMAIL_JSONB,
      errorMessageEmailTemplate: {}
    }
    onChangeEmailTemplateHOC = ( key, val ) => this.setState({ [key]: val })

    load = param => this.setState({ loading: param })
    requestSuccess = success => toast.success( success )
    requestError = error => {
      if( typeof error === 'string' ) {
        toast.error( error )
      } else {
        let tmpError = _.reduce( 
          error, 
          ( res, val, key ) => ({ ...res, [ key ]: val.replace( /_/g, ' ' ) }),
          {}
        )
        _.map( tmpError, ( err, errKey ) => toast.error( err ) )
        this.setState({ errorMessageEmailTemplate: tmpError })
      }
    }

    getEmailTemplates = () => {
      Get(
        `/api/v1/fex/client_email_templates/${this.props.data.selectCenterReducer.selectedCenter.center.client_id}`,
        this.getEmailTemplatesSuccess,
        this.getEmailTemplatesError,
        this.load
      )
    }
    getEmailTemplatesSuccess = payload => {
      let tmp = _.cloneDeep( payload )
      if( _.isEmpty( payload.content_jsonb ) ){
        tmp[ 'content_jsonb' ] = DEFAULT_EMAIL_JSONB
      }
      this.setState({ emailTemplates: tmp, emailTemplateContentJsonb: tmp.content_jsonb })
    }
    getEmailTemplatesError = error => this.requestError( error )

    updateEmailTemplate = ( data ) => {
      Put(
        `/api/v1/fex/client_email_templates/${this.props.data.selectCenterReducer.selectedCenter.center.client_id}`,
        {
          ...data,
        },
        this.updateEmailTemplateSuccess,
        this.updateEmailTemplateError,
        this.load
      )
    }
    updateEmailTemplateSuccess = () => {
      this.requestSuccess( Lang[ 'RECORD_UPDATE_SUCCESS' ][ this.props.data.languageReducer.userSettings.admin_panel_language ] )
      this.getEmailTemplates()
      this.setState({ errorMessageEmailTemplate: {} })
    }
    updateEmailTemplateError = error => this.requestError( error )

    render = () => {
      return(
        <WrappedComponent
          { ...this.props }
          onLoadEmailTemplate={ this.state.loading }
          emailTemplates={ this.state.emailTemplates }
          emailTemplateContentJsonb={ this.state.emailTemplateContentJsonb }
          errorMessageEmailTemplate={ this.state.errorMessageEmailTemplate }
          getEmailTemplates={ this.getEmailTemplates }
          onChangeEmailTemplateHOC={ this.onChangeEmailTemplateHOC }
          updateEmailTemplate={ this.updateEmailTemplate }
        />
      )
    }
  }
  const mapStateToProps = state => ({ data: state })
  return connect( mapStateToProps )( WithHOC )
}

export default HOC